module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiYjVjNjE4MWZlNDgxNzMwZWUzMGQwZDA4YjY5NzI3MTYucG5nIjs="